// export { LoginPage } from './login';
export { ListFormPage as ListFormPageDynamic } from './list_form';
export { FormPage as FormPageDynamic} from './form';
export { ListFormResponsePage as ListFormResponsePageDynamic} from './list_form_response';
export { DetailResponsePage as DetailResponsePageDynamic} from './detail_response';


// WEBPACK FOOTER //
// ./src/pages/dynamic_form/index.ts